export default "__VITE_ASSET__BHqg6Pqr__"